import { Modal, ModalProps } from 'antd';
import React from 'react';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { css } from '@emotion/css';
import posthog from '@leyan/lytics';
import CheckContainer from 'components/CheckContainer';
import { useFilterCtx } from './Filter';

const Container = styled.div``;
const Desc = styled.div`
  color: #232426;
  .before {
    height: 14px;
    border-left: 4px solid #3366ff;
    display: inline-block;
    margin-right: 6px;
    margin-bottom: -1px;
  }
`;
const Item = styled.div`
  margin-top: 16px;
  > * {
    width: 100%;
    padding: 20px 16px;
  }
`;
const modalCls = css`
  .ant-modal-body {
    padding: 12px 24px 40px 24px;
  }
`;

interface Props extends ModalProps {}

const PerfRuleSelectorModal = (props: Props) => {
  const { t } = useTranslate();

  const { value, onChange } = useFilterCtx();

  const { convertRule } = value;

  const isChecked = (rule: (typeof value)['convertRule']) => rule === convertRule;

  const handleChange = (checked: boolean, convertRule: (typeof value)['convertRule']) => {
    if (!checked) {
      return;
    }

    onChange({
      ...value,
      convertRule,
    });

    posthog.capture('$assistantPerformance', {
      type: 'convertRuleChecked',
      convertRule,
    });
  };

  return (
    <Modal title={t('ViewDashboard.绩效考核项计算规则')} {...props} className={modalCls}>
      <Container>
        <Desc>
          <div className="before" />
          {t('ViewDashboard.接待后下单或付款的计算规则')}
        </Desc>
        <Item>
          <CheckContainer checked={isChecked(1)} onChange={(checked) => handleChange(checked, 1)}>
            {t('ViewDashboard.为每一位接待买家的 客服坐席 计算转化')}
          </CheckContainer>
        </Item>
        <Item>
          <CheckContainer checked={isChecked(2)} onChange={(checked) => handleChange(checked, 2)}>
            {t('ViewDashboard.仅为最后1位接待买家的 客服坐席 计算转化')}
          </CheckContainer>
        </Item>
      </Container>
    </Modal>
  );
};

export default PerfRuleSelectorModal;
